export const featuredPortfolio = [
    {
      id: 1,
      title: "Marketplace App",
      img:
        "assets/ezstack.png",
        link:"https://www.youtube.com/watch?v=ZaRFGYO2HQ4&list=PLx0iOsdUOUmkAw0zV4kJO8Ci80W5muK7R&index=16&themeRefresh=1"
        
    },
    {
      // id: 2,
      // title: "E-commerce App",
      // img:
      //   "assets/soulshopper.png",
      //   link:"https://jdvasquez26.github.io/Google-translate-clone/"
      id: 2,
      title: "Fitness App",
      img: "assets/jestfit.png",
      link:"https://jestfit.netlify.app/"
    },
    {
      id: 3,
      title: "Music App - Musika",
      img:
        "assets/musika.png",
        link:"https://musikaa.netlify.app/"
    },
    // {
    //   id: 4,
    //   title: "Relax Mobile App",
    //   img:
    //     "https://cdn.dribbble.com/users/4095861/screenshots/15467417/media/d6a15c416626f12b31fa5ca1db192572.png?compress=1&resize=1200x900",
    // },
    // {
    //   id: 5,
    //   title: "Hero Web Design",
    //   img:
    //     "https://cdn.dribbble.com/users/5031392/screenshots/15467520/media/c36b3b15b25b1e190d081abdbbf947cf.png?compress=1&resize=1200x900",
    // },
    // {
    //   id: 6,
    //   title: "Banking App",
    //   img:
    //     "https://cdn.dribbble.com/users/3307260/screenshots/15468444/media/447b4501f7a145b05e11c70199a9c417.jpg?compress=1&resize=1200x900",
    // },
  ];
  
  export const webPortfolio = [
    {
      id: 1,
      title: "Marketplace App",
      img:
        "assets/ezstack.png",
        link:"https://www.youtube.com/watch?v=ZaRFGYO2HQ4&list=PLx0iOsdUOUmkAw0zV4kJO8Ci80W5muK7R&index=16&themeRefresh=1"
    },
    {
      id: 2,
      title: "E-commerce App",
      img:
        "assets/soulshopper.png",
        link:"https://jdvasquez26.github.io/Google-translate-clone/"
    },
    // {
    //   id: 3,
    //   title: "Google Translate Clone",
    //   img:
    //     "assets/googletranclone.png",
    //   link: "https://jdvasquez26.github.io/Google-translate-clone/"
    // },
    {
      id: 3,
      title: "Music App - Musika",
      img: "assets/musika.png",
      link:"https://musikaa.netlify.app/"
    },
    {
      id: 4,
      title: "Fitness App",
      img: "assets/jestfit.png",
      link:"https://jestfit.netlify.app/"
    },
    // {
    //   id: 6,
    //   title: "Web Banking App",
    //   img: "https://cdn.dribbble.com/users/6384483/screenshots/15468426/media/ce9479fa1f8dba3a4a49840d76e55e31.png?compress=1&resize=1200x900",
    // },
  ];
  
  export const mobilePortfolio = [
    // {
    //   id: 1,
    //   title: "Social Media App",
    //   img:
    //     "https://cdn.dribbble.com/users/2597268/screenshots/15468893/media/44313553d73ba41580f1df69749bba28.jpg?compress=1&resize=1200x900",
    // },
    // {
    //   id: 2,
    //   title: "Rampa UI Design",
    //   img:
    //     "https://cdn.dribbble.com/users/5920881/screenshots/15463142/media/b5a460223798bd85d835710806e2f3dd.png?compress=1&resize=1200x900",
    // },
    // {
    //   id: 3,
    //   title: "E-commerce Design",
    //   img:
    //     "https://cdn.dribbble.com/users/1998175/screenshots/15459384/media/48ac2b43ebe81ba0866afea1383cc939.png?compress=1&resize=1200x900",
    // },
    // {
    //   id: 4,
    //   title: "Relax App",
    //   img:
    //     "https://cdn.dribbble.com/users/2083704/screenshots/15468619/media/cd958306c7a772449e1ac23bd65ce506.png?compress=1&resize=1200x900",
    // },
    // {
    //   id: 5,
    //   title: "Hero Design",
    //   img:
    //     "https://cdn.dribbble.com/users/26642/screenshots/15462545/media/1a202ef5c8338b6f78634e6edc1ba350.png?compress=1&resize=1200x900",
    // },
    // {
    //   id: 6,
    //   title: "Banking App",
    //   img:
    //     "https://cdn.dribbble.com/users/1387827/screenshots/15466426/media/deb2dca6762cd3610321c98bfccb0b72.png?compress=1&resize=1200x900",
    // },
  ];
  
  export const designPortfolio = [
    {
      id: 1,
      title: "Design Social Media App",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
    },
    {
      id: 2,
      title: "Design Rampa UI Design",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
    },
    {
      id: 3,
      title: "Design E-comm Web Design",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
    },
    {
      id: 4,
      title: "Design Relax Mobile App",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
    },
    {
      id: 5,
      title: "Design Keser Web Design",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
    },
    {
      id: 6,
      title: "Design Banking App",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
    },
  ];
  
  export const contentPortfolio = [
    {
      id: 1,
      title: "Content Social Media App",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
    },
    {
      id: 2,
      title: "Content Rampa UI Design",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
    },
    {
      id: 3,
      title: "Content E-commerce Web Design",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
    },
    {
      id: 4,
      title: "Content Relax Mobile App",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
    },
    {
      id: 5,
      title: "Content Keser Web Design",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
    },
    {
      id: 6,
      title: "Content Banking App",
      img:
        "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRKvdHn8GmPGCO0y3SJqNHACygpm0h9VycMHg&usqp=CAU",
    },
  ];